/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SearchTimeOffChangeProposalsRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {SearchTimeOffChangeProposalsResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const searchTimeOffChangeProposals = (request: SearchTimeOffChangeProposalsRequest, options?: CashRequestOptions) => post<SearchTimeOffChangeProposalsRequest, SearchTimeOffChangeProposalsResponse>("/2.0/cash/search-time-off-change-proposals", request, {...options, rejectOnError: true })